<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>

              <template slot="header">

                <v-toolbar class="primary" :height="56" flat dark>
                  <v-toolbar-title>
                    <span class="body-2 uppercase">{{ $t('templates') }}</span>
                  </v-toolbar-title>
                </v-toolbar>

              </template>

              <template slot="body">
                <v-layout column fill-height justify-start ma-0 pa-0 >
                  <scroll-table
                    :data="getTable"
                    :options="getOptions"
                    :subscribed="false"
                    :headUppercase="false"
                    @select=""
                    @value="(payload)=>onSelect(payload)"
                    @remove=""
                  />
                </v-layout>
              </template>

            </scroll-area>

          </v-layout>
        </v-flex>
        
      </v-layout>

    </v-layout>

    <v-dialog persistent v-model="dialog.open" max-width="1200px" v-if="dialog.open">
      <ztp-templates-card
        :data="getDialogData"
        :parentData="getData"
        @update="(payload) => onUpdate(payload)"
        @add=""
        @remove=""
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import ztpTemplatesCard from '@/nms/pages/configuration/components/ztp-templates-card.vue'

// Типы
interface DialogState {
  open: boolean
  addMode: boolean
  name: string | null
  data: any | null
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableRow {
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface TemplateItem {
  manufacturer?: string
  vendorCode?: string
  deviceType?: string
  name?: string
  [key: string]: any
}

interface TemplateResponse {
  data?: TemplateItem[]
  [key: string]: any
}

interface PatternResponse {
  data?: any
  [key: string]: any
}

interface UpdateData {
  template?: string
  pattern?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'ZTP_TEMPLATES',

  components: {
    scrollArea,
    scrollTable,
    ztpTemplatesCard
  },

  props: {
    data: {
      type: Object as () => any,
      default: () => ({})
    },
  },

  data(): {
    dialog: DialogState
    model: Record<string, any>
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      dialog: {
        open: false,
        addMode: false,
        name: null,
        data: null,
      },
      model: {},
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [],
        rows: [],
      },
    }
  },

  computed: {
    getData(): any {
      return this.data
    },

    getDialogData(): any | null {
      return this.dialog.data
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.manufacturer?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.vendorCode?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.deviceType?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },

    getOptions(): OptionsData {
      return this.options
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadTemplates()
    },

    async loadTemplates(): Promise<void> {
      console.log(this.$options.name, 'loadTemplates', 'START')
      try {
        const templates = await this.$bridge.customQuery('alarm', 'DHCP/showZtpList', {}, 'get') as TemplateResponse
        console.log(this.$options.name, 'loadTemplates', 'list', templates)
        if (templates?.data) {
          this.prepareTable(templates.data)
        }
      } catch (error) {
        console.error(this.$options.name, 'loadTemplates smth wrong', error)
      }
    },

    async prepareTable(templates: TemplateItem[]): Promise<void> {
      console.log(this.$options.name, 'prepareTable', 'templates', templates)
      if (!templates?.length) return

      try {
        const columns: TableColumn[] = []
        const firstTemplate = templates[0]
        Object.keys(firstTemplate).forEach(key => {
          const column: TableColumn = {
            title: key,
            value: key,
            type: 'text',
            width: '20%'
          }
          columns.push(column)
        })
        this.$set(this.table, 'columns', columns)

        const rows: TableRow[] = []
        templates.forEach(template => {
          rows.push(template)
        })
        this.$set(this.table, 'rows', rows)
      } catch (error) {
        console.error(this.$options.name, 'prepareTable smth wrong', error)
      }
    },

    async onSelect(val: TemplateItem): Promise<void> {
      console.log(this.$options.name, 'onSelect', 'val', val)
      if (!val) return

      this.$set(this.dialog, 'data', {})
      this.$set(this.dialog, 'open', true)

      try {
        const templateName = `${val.manufacturer} ${val.vendorCode}`
        const t = await this.$bridge.customQuery('alarm', 'DHCP/showOptPattern', { template: templateName }, 'get') as PatternResponse
        if (t) {
          this.$set(this.dialog.data, 'template', t.data)
        }

        const n = await this.$bridge.customQuery('alarm', 'DHCP/getPatternFileJinja2', {
          manufacturer: val.manufacturer,
          vendor_code: val.vendorCode,
          device_type: val.deviceType,
          filename: 'ztp.jinja2'
        }, 'get') as PatternResponse
        if (n) {
          this.$set(this.dialog.data, 'pattern', n)
        }
      } catch (error) {
        console.error(this.$options.name, 'onSelect smth wrong', error)
      }
    },

    onDialogClose(): void {
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    async onUpdate(val: UpdateData): Promise<void> {
      console.log(this.$options.name, 'onUpdate', 'val', val)
      if (!val?.template) return

      try {
        const u = await this.$bridge.customQuery('alarm', '/DHCP/changeJinjaPattern', val, 'put')
        if (u) {
          console.log(this.$options.name, 'onUpdate', 'u', u)
          this.$dialog.notify.success('update success', { timeout: 5000 })
          this.setup()
        } else {
          console.error('CATCH', this.$options.name, 'onUpdate', 'smth wrong')
        }
      } catch (error) {
        console.error(this.$options.name, 'onUpdate smth wrong', error)
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
